<template>
        <el-dialog title="新增" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item v-if="!homeEdit" label="登录名" prop="FCode">
                    <el-input v-model="form.FCode"></el-input>
                </el-form-item>
                <el-form-item v-if="!homeEdit" label="密码">
                    <el-input type="password" v-model="form.FPassWord" placeholder="********"></el-input>
                </el-form-item>
                <el-form-item v-if="!homeEdit" label="用户名" prop="FName">
                    <el-input v-model="form.FName"></el-input>
                </el-form-item>
                <el-form-item v-if="!homeEdit" label="真实名字">
                    <el-input v-model="form.FRealName"></el-input>
                </el-form-item>
                <el-form-item label="手机">
                    <el-input v-model="form.FPhone"></el-input>
                </el-form-item>
                <el-form-item label="办公电话">
                    <el-input v-model="form.FTelPhone"></el-input>
                </el-form-item>
                <el-form-item label="邮箱">
                    <el-input v-model="form.FEMail"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="form.FNote"></el-input>
                </el-form-item>
                <el-form-item v-if="form.FID>=0" label="管辖区域" prop="device_dept">
                    <sy-cascader v-model="depts" style="width:100%"
                                 optionsData="server/system/Dept.ashx?cmd=GetSelDeptTree">
                    </sy-cascader>
                </el-form-item> 
                <el-form-item v-if="form.FID>=0" label="系统角色" prop="FRoleID"> 
                    <sy-select v-model="form.FRoleID"
                               optionData="server/system/Role.ashx?cmd=GetOptionsSys">
                    </sy-select>
                </el-form-item>
                <!-- <el-form-item label="总部管理员" prop="FIsManager">
                    <el-radio-group :disabled="!isAdmin" v-model="form.FIsManager">
                        <el-radio :label="1" >是</el-radio>
                        <el-radio :label="0" >否</el-radio>
                    </el-radio-group>
                </el-form-item> -->

                <!-- <el-form-item label="启用模块" prop="FAuths">
                    <el-checkbox  :indeterminate="isIndeterminate"  v-model="checkAll"  @change="handleCheckAllChange">全选</el-checkbox>
                    <el-checkbox-group v-model="moudleList" @change="handleCheckedMoudleChange">
                        <el-checkbox label="1">室内地图</el-checkbox>
                        <el-checkbox label="2">室外地图</el-checkbox>
                        <el-checkbox label="3">电子围栏</el-checkbox>
                        <el-checkbox label="4">SOS报警</el-checkbox>
                        <el-checkbox label="5">拆除报警</el-checkbox>
                        <el-checkbox label="6">体温报警</el-checkbox>
                        <el-checkbox label="7">越界报警</el-checkbox>
                        <el-checkbox label="8">系统用户</el-checkbox>
                        <el-checkbox label="9">基础设置</el-checkbox>
                    </el-checkbox-group>
                </el-form-item> -->

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
      </el-dialog>
</template>

<script>
    const moudleOptions = ["1","2","3","4","5","6","7","8","9"]
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        props:{
            homeEdit:Boolean
        },
        data() {
            return {
                isAdmin:(global.user.FID == -1),
                form: {},
                rules: {
                    FCode: [{required: true,message: '请输入登录名', trigger: 'blur'}],
                    FName: [{required: true,message: '请输入用户名', trigger: 'blur'}],
                    FRoleID: [{required: true,message: '请输入系统角色', trigger: 'blur'}]
                },
                loading:false,
                editFormVisible:false,
                moudleList:[],
                checkAll:true,
                isIndeterminate: false
            }
        },
        methods: {
            handleCheckAllChange(val){
              this.moudleList = val ? moudleOptions : [];
              this.isIndeterminate = false;
            },
            handleCheckedMoudleChange(value){
                let checkedCount = value.length
                this.checkAll = (checkedCount === moudleOptions.length)
                this.isIndeterminate = (checkedCount > 0 && checkedCount < moudleOptions.length)
            },
            _openEdit(record) {
                debugger
                this.editFormVisible = true
                this.form = Object.assign({},record)
                if(this.form.FDeptLabel) {
                    this.depts = this.form.FDeptLabel.split(',')
                    this.depts=this.depts.map(function(data){
                        return +data;
                    });
                }
                else{
                    this.depts =[]
                }
                if(this.form.FAuths){
                    this.moudleList = this.form.FAuths.split(",")
                }
                this.checkAll = (this.moudleList.length === moudleOptions.length)
                debugger
                this.isIndeterminate = (this.moudleList.length > 0 && this.moudleList.length < moudleOptions.length)
            },
            _openAdd() {
                this.editFormVisible = true
                this.form = {FID:0,FType:1,FIsMainMap:0,FIsManager:0,FRoleID:null}
                this.form.FDeptID = global.user.FDeptID
                this.form.FDeptLabel = global.user.FDeptLabel
                if(this.form.FDeptLabel) {
                    this.depts=this.form.FDeptLabel.split(',').map(function(data){
                        return +data;
                    });
                }
                else{
                    this.depts =[]
                }
                if(global.topUser && global.topUser.FAuths){
                    this.moudleList = global.topUser.FAuths.split(",")
                }else{
                    this.moudleList = moudleOptions
                }
            },
            save:function () {
                if(this.form.FID>=0){
                    if(this.depts.length>0){
                        this.form.FDeptID = this.depts[this.depts.length-1]
                    }
                    else{
                        util.msgWarning("请填写所属机构")
                        return
                    }
                    // if(!this.form.FRoleID){
                    //     util.msgWarning("请填写角色")
                    //     return
                    // }
                }
                this.form.FAuths = this.moudleList.join(",")
                util.saveForm("server/system/User.ashx?cmd=SaveUser",this.$refs.form,this.form,this.loadFn,result=> {
                    util.msgSuc("保存成功")
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
            },
          isValidIp(e) {
            return /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/.test(e)
          }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/system/User_Edit.vue